import React from "react";

const suggestedProducts = [
  {
    id: 1,
    name: "Wireless Headphones",
    price: 2999,
    image:
      "https://static.vecteezy.com/system/resources/thumbnails/024/841/280/small_2x/wireless-headphone-isolated-on-transparent-background-high-quality-bluetooth-headphone-for-advertising-and-product-catalogs-generative-ai-png.png",
  },
  {
    id: 2,
    name: "Smart Watch",
    price: 4999,
    image:
      "https://qualitycomputer.com.np/web/image/product.template/50321/image_1024?unique=9a34757",
  },
  {
    id: 3,
    name: "Sneakers",
    price: 2599,
    image:
      "https://m.media-amazon.com/images/I/81FzSswwCVL.jpg",
  },
  {
    id: 4,
    name: "Modern Lamp",
    price: 1899,
    image:
      "https://m.media-amazon.com/images/I/613CCQvc74L._AC_UF350,350_QL80_.jpg",
  },
  {
    id: 5,
    name: "Backpack",
    price: 1599,
    image:
      "https://img4.dhresource.com/webp/m/0x0/f3/albu/jc/y/18/1ac0f876-1acf-476f-84ad-01fdfe4830c3.jpg",
  },
  {
    id: 6,
    name: "Gaming Mouse",
    price: 1999,
    image:
      "https://www.mytrendyphone.co.uk/images/6D-4-Speed-DPI-RGB-Gaming-Mouse-G5-Black-05042021-01-p.webp",
  },
];

const SuggestedSection = () => {
  return (
    <div className="bg-white rounded-xl m-2 md:m-8 md:rounded-none py-3 px-4 md:px-12">
      <h2 className="text-xl md:text-2xl font-semibold text-gray-800 mb-6">
        Suggested for You
      </h2>

      {/* Responsive Grid */}
      <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-6">
        {suggestedProducts.map((product) => (
          <div
            key={product.id}
            className="bg-gray-100 rounded-lg transition p-3 flex flex-col items-center cursor-pointer hover:shadow-lg"
          >
            <div className="w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 flex items-center justify-center">
              <img
                src={product.image}
                alt={product.name}
                className="w-full h-full object-contain"
              />
            </div>
            <h3 className="mt-2 text-[10px] sm:text-sm md:text-base font-medium text-gray-700 text-center line-clamp-1">
              {product.name}
            </h3>
            <p className="text-green-600 text-xs sm:text-sm md:text-base font-semibold mt-1">
              Rs. {product.price}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SuggestedSection;
